<template>
<div class="example">
  <!-- <div class="article" v-if="article" v-html="article.content"> -->
    <div class="example-title">
        <a href="" title="网站首页">网站首页</a>
        >
        <a href="" title="成功案例">成功案例</a>
        >
        {{article.title}}
    </div>
    <div class="article" v-if="article">
      <h1>{{article.title}}</h1>
      <!-- <div class="article-info">
          <span class="author">{{article.author}}</span>
          <span class="time">{{article.created}}</span>
        </div> -->
        <div class="article-content">
          <img :src="article.photo" alt="">
          <div class="padding-top-20"></div>
          <p style="padding: 0 6%;text-align: left;">{{article.content}}</p>
          <div class="padding-top-20"></div>
          <h3 style="padding: 0 6%;text-align: left;">{{article.author}}</h3>
          <div class="padding-top-20"></div>
        </div>
        <!-- <div class="article-footer">
          <div class="small-font-grey">来源:{{article.source}}</div>
          <div class="go-back"><i-button type="text" @click="$router.push({path:'/'})">返回文章列表</i-button></div>
        </div> -->
    </div>
      <!-- <div>{{article.brief}}</div>rsthrsths -->
  </div>
<!-- </div> -->
</template>

<script>
// import exampleList from './policies.json'
export default {
  props: ['informationList'],
  data () {
    return {
      article: {}
      // exampleList: {}
    }
  },
  watch: {
    'informationList': function (val) {
      if (val instanceof Array) {
        this.article = this.informationList.filter((item) => {
          return item.tid.toString() === this.$route.params.tid
        })[0]
      }
    },
    '$route.params.tid': function (val) {
      if (val) {
        this.article = this.informationList.filter((item) => {
          return item.tid.toString() === val
        })[0]
      }
    }
  },
  mounted () {
    if (this.$route.params.tid) {
      this.article = this.informationList.filter((item) => {
        return item.tid.toString() === this.$route.params.tid
      })[0]
      // return item.tid.toString() === this.$route.params.tid
    }
  }
}
</script>

<style lang="less" scoped>
.example {
  // padding: 20px 10% 80px 10%;
  font-size: 13px;
  // min-width: 1200px;
  width: 96%;
  max-width: 1200px;
  margin: 0 auto;
}
.example-title {
  padding: 20px 0 40px 0;
  font-size: 15px;
  a {
    color: #515a6e;
  }
}
.article {
  display: flex;
  flex-direction: column;
  align-items: center;
  .article-info {
    padding: 10px;
    width: 60%;
    text-align: center;
    border-bottom: 1px dashed #ccc;
  }
  .article-content {
    font-size: 16px;
    // text-indent: 2em;
    line-height: 1.8em;
    margin: 50px 40px;
    text-align: center;
    img {
      width: 75%;
      height: 320px;
    }
    p {
      margin: 4em 0 !important;
    }
  }
  .article-footer {
    margin-top: 40px;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .small-font-grey {
      color: #aaa;
    }
  }
  .article-content p {
  margin: 1.1em 0 !important;
}
.padding-top-20 {
  padding-top: 20px;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/example/view.vue